module.exports = __webpack_public_path__ + "static/img/contant_2.3ce682d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_4/contant_2.jpg
// module id = GZOf
// module chunks = 0